import $ from 'jquery';

window.stepBack = function(elem) {
  const stepElement = $('#step');
  const step = stepElement.val();
  stepElement.val(step - 2);
  $(elem).closest('form').submit();
};